import * as React from "react";
const SvgFilePencilAlt = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.8332 2.5H8.1665C6.76637 2.5 6.06631 2.5 5.53153 2.77248C5.06112 3.01217 4.67867 3.39462 4.43899 3.86502C4.1665 4.3998 4.1665 5.09987 4.1665 6.5V13.5C4.1665 14.9001 4.1665 15.6002 4.43899 16.135C4.67867 16.6054 5.06112 16.9878 5.53153 17.2275C6.06631 17.5 6.76637 17.5 8.1665 17.5H8.33317M10.8332 2.5L15.8332 7.5M10.8332 2.5V4.83333C10.8332 5.76675 10.8332 6.23346 11.0148 6.58998C11.1746 6.90359 11.4296 7.15856 11.7432 7.31834C12.0997 7.5 12.5664 7.5 13.4998 7.5H15.8332M15.8332 7.5V8.33333M7.49984 14.1667H9.58317M7.49984 10.8333H11.6665M7.49984 7.5H8.33317M11.6665 17.5L13.354 17.1625C13.5011 17.1331 13.5747 17.1184 13.6433 17.0915C13.7042 17.0676 13.762 17.0366 13.8157 16.9992C13.8761 16.957 13.9292 16.904 14.0353 16.7979L17.4998 13.3333C17.9601 12.8731 17.9601 12.1269 17.4998 11.6667C17.0396 11.2064 16.2934 11.2064 15.8332 11.6667L12.3686 15.1312C12.2625 15.2373 12.2095 15.2904 12.1673 15.3508C12.1299 15.4045 12.0989 15.4623 12.075 15.5232C12.0481 15.5918 12.0334 15.6654 12.004 15.8125L11.6665 17.5Z",
      stroke: "#131A29",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgFilePencilAlt;
